import PromiseBB from "bluebird";
import * as path from "path";
import * as React from "react";
import { Alert, Button, ControlLabel, FormControl, FormGroup, HelpBlock, } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getPreloadApi } from "../../util/preloadAccess";
import { showDialog } from "../../actions/notifications";
import { resetSuppression } from "../../actions/notificationSettings";
import { setCustomTitlebar } from "../../actions/window";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import More from "../../controls/More";
import Toggle from "../../controls/Toggle";
import { relaunch } from "../../util/commandLine";
import getVortexPath from "../../util/getVortexPath";
import { log } from "../../util/log";
import { truthy } from "../../util/util";
import { readExtensibleDir } from "../extension_manager/util";
import getTextModManagement from "../mod_management/texts";
import getTextProfiles from "../profile_management/texts";
import { setAutoDeployment, setAutoEnable, setAutoInstall, setAutoStart, setStartMinimized, } from "./actions/automation";
import { setAdvancedMode, setDesktopNotifications, setForegroundDL, setHideTopLevelCategory, setLanguage, setProfilesVisible, setRelativeTimes, } from "./actions/interface";
import { nativeCountryName, nativeLanguageName } from "./languagemap";
import getText from "./texts";
class SettingsInterfaceImpl extends ComponentEx {
    mInitialTitlebar;
    constructor(props) {
        super(props);
        this.mInitialTitlebar = props.customTitlebar;
    }
    componentDidMount() {
        this.props.startup.attach(this);
    }
    componentWillUnmount() {
        this.props.startup.detach(this);
    }
    render() {
        const { t, autoDeployment, autoEnable, autoInstall, autoStart, currentLanguage, customTitlebar, desktopNotifications, foregroundDL, languages, profilesVisible, hideTopLevelCategory, onSetForegroundDL, relativeTimes, startup, startMinimized, suppressedNotifications, } = this.props;
        const needRestart = customTitlebar !== this.mInitialTitlebar;
        const startMinimizedToggle = autoStart ? (React.createElement(Toggle, { checked: startMinimized, onToggle: this.toggleMinimized }, t("Start Vortex in the background (Minimized)"))) : null;
        const restartNotification = needRestart ? (React.createElement(HelpBlock, null,
            React.createElement(Alert, null,
                t("You need to restart Vortex to activate this change"),
                React.createElement(Button, { style: { marginLeft: "1em" }, onClick: this.restart }, t("Restart now"))))) : null;
        const numSuppressed = Object.values(suppressedNotifications).filter((val) => val === true).length;
        return (React.createElement("form", null,
            React.createElement(FormGroup, { controlId: "languageSelect" },
                React.createElement(ControlLabel, null, t("Language")),
                React.createElement(FormControl, { componentClass: "select", value: currentLanguage, onChange: this.selectLanguage }, languages.reduce((prev, language) => {
                    if (language.ext.length < 2) {
                        prev.push(this.renderLanguage(language));
                    }
                    else {
                        language.ext.forEach((ext) => prev.push(this.renderLanguage(language, ext)));
                    }
                    return prev;
                }, [])),
                React.createElement(ControlLabel, null, t("When you select a language for the first time you may have to restart Vortex."))),
            React.createElement(FormGroup, { controlId: "customization" },
                React.createElement(ControlLabel, null, t("Customisation")),
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: customTitlebar, onToggle: this.toggleCustomTitlebar }, t("Custom Window Title Bar"))),
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: desktopNotifications !== false, onToggle: this.toggleDesktopNotifications }, t("Enable Desktop Notifications"))),
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: hideTopLevelCategory, onToggle: this.toggleHideTopLevelCategory },
                            t("Hide Top-Level Category"),
                            React.createElement(More, { id: "more-hide-toplevel-category", name: t("Top-Level Categories") }, getText("toplevel-categories", t)))),
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: relativeTimes, onToggle: this.toggleRelativeTimes }, t('Use relative times (e.g. "3 months ago")')))),
                React.createElement("div", null,
                    React.createElement(Toggle, { checked: foregroundDL, onToggle: onSetForegroundDL }, t("Bring Vortex to foreground when starting downloads in browser")))),
            React.createElement(FormGroup, { controlId: "advanced" },
                React.createElement(ControlLabel, null, t("Advanced")),
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: profilesVisible, onToggle: this.toggleProfiles },
                            t("Enable Profile Management"),
                            React.createElement(More, { id: "more-profile-settings", name: t("Profiles"), wikiId: "profiles" }, getTextProfiles("profiles", t)))),
                    React.createElement("div", null,
                        React.createElement(Toggle, { checked: startup.disableGPU !== true, onToggle: this.toggleAcceleration }, t("Enable GPU Acceleration")),
                        startup.disableGPU === true ? (React.createElement(ControlLabel, null,
                            React.createElement(Alert, { bsStyle: "warning" }, t("Disabling GPU acceleration will make the Vortex UI significantly less " +
                                "responsive in places.")))) : null))),
            React.createElement(FormGroup, { controlId: "automation" },
                React.createElement(ControlLabel, null, t("Automation")),
                React.createElement("div", null,
                    React.createElement(Toggle, { checked: autoDeployment, onToggle: this.toggleAutoDeployment },
                        t("Deploy Mods when Enabled"),
                        React.createElement(More, { id: "more-deploy-settings", name: t("Deployment") }, getTextModManagement("deployment", t))),
                    React.createElement(Toggle, { checked: autoInstall, onToggle: this.toggleAutoInstall }, t("Install Mods when downloaded")),
                    React.createElement(Toggle, { checked: autoEnable, onToggle: this.toggleAutoEnable }, t("Enable Mods when installed (in current profile)")),
                    React.createElement(Toggle, { checked: autoStart, onToggle: this.toggleAutoStart }, t("Run Vortex when my computer starts")),
                    startMinimizedToggle)),
            React.createElement(FormGroup, { controlId: "notifications" },
                React.createElement(ControlLabel, null, t("Notifications")),
                React.createElement("div", null,
                    React.createElement(Button, { onClick: this.resetSuppression }, t("Reset suppressed notifications")),
                    " ",
                    t("({{count}} notification is being suppressed)", {
                        replace: { count: numSuppressed },
                    }))),
            restartNotification));
    }
    toggleAcceleration = () => {
        this.props.changeStartup("disableGPU", this.props.startup.disableGPU !== true);
    };
    toggleRelativeTimes = () => {
        this.props.onSetRelativeTimes(!this.props.relativeTimes);
    };
    selectLanguage = (evt) => {
        const { extensions } = this.props;
        const target = evt.target;
        const extName = target.selectedOptions[0]?.getAttribute("data-ext");
        if (extName === undefined) {
            // no language selected? How did this happen?
            return;
        }
        const ext = extensions.find((iter) => iter.name === extName) || {};
        const { value } = target;
        const dlProm = ext.modId !== undefined
            ? this.context.api
                .emitAndAwait("install-extension", ext)
                .tap((success) => success ? this.props.onReloadLanguages() : PromiseBB.resolve())
            : PromiseBB.resolve([true]);
        dlProm.then((success) => {
            if (success.indexOf(false) === -1) {
                this.props.onSetLanguage(value);
            }
        });
    };
    languageName(language) {
        return language.country === undefined
            ? language.language
            : `${language.language} (${language.country})`;
    }
    renderLanguage(language, ext) {
        const { t } = this.props;
        if (ext === undefined) {
            ext = language.ext.length > 0 ? language.ext[0] : { name: undefined };
        }
        return (React.createElement("option", { "data-ext": ext.name, key: `${language.key}-${ext["author"] || "local"}`, value: language.key },
            this.languageName(language),
            ext.modId !== undefined
                ? ` (${t("Extension")} by ${ext["author"] || "unknown author"})`
                : null));
    }
    toggleAutoDeployment = () => {
        const { autoDeployment, onSetAutoDeployment } = this.props;
        onSetAutoDeployment(!autoDeployment);
    };
    toggleAutoInstall = () => {
        const { autoInstall, onSetAutoInstall } = this.props;
        onSetAutoInstall(!autoInstall);
    };
    toggleAutoEnable = () => {
        const { autoEnable, onSetAutoEnable } = this.props;
        onSetAutoEnable(!autoEnable);
    };
    toggleAutoStart = () => {
        const { autoStart, startMinimized, onSetAutoStart, onSetStartMinimized } = this.props;
        const startOnBoot = !autoStart === true;
        onSetAutoStart(startOnBoot);
        if (!startOnBoot) {
            // We only want to allow the user to start Vortex minimized
            //  if auto start is enabled - easier this way and less chances
            //  for users to forget about this setting and start sending
            //  bug reports.
            onSetStartMinimized(false);
        }
        const api = getPreloadApi();
        api.app.setLoginItemSettings({
            openAtLogin: startOnBoot,
            path: process.execPath, // Yes this is currently needed - thanks Electron
            args: startOnBoot ? (startMinimized ? ["--start-minimized"] : []) : [],
        });
    };
    toggleMinimized = () => {
        const { autoStart, startMinimized, onSetStartMinimized } = this.props;
        const isMinimized = !startMinimized === true;
        onSetStartMinimized(isMinimized);
        const api = getPreloadApi();
        api.app.setLoginItemSettings({
            openAtLogin: autoStart,
            path: process.execPath, // Yes this is currently needed - thanks Electron
            args: isMinimized ? ["--start-minimized"] : [],
        });
    };
    resetSuppression = () => {
        const { onResetNotificationSuppression } = this.props;
        onResetNotificationSuppression();
    };
    toggleDesktopNotifications = () => {
        const { desktopNotifications, onSetDesktopNotifications } = this.props;
        onSetDesktopNotifications(!desktopNotifications);
    };
    toggleHideTopLevelCategory = () => {
        const { hideTopLevelCategory, onSetHideTopLevelCategory } = this.props;
        onSetHideTopLevelCategory(!hideTopLevelCategory);
    };
    toggleProfiles = () => {
        const { t, profilesVisible, onSetProfilesVisible, onShowDialog } = this.props;
        if (profilesVisible) {
            onShowDialog("question", t("Disabling Profile Management"), {
                text: t("Please be aware that toggling this only disables the interface for profiles, " +
                    "meaning profiles don't get deleted and an active profile doesn't " +
                    "get disabled. The last active profile for each game will still be used " +
                    "(i.e. its mod selection and local savegames)."),
                options: { translated: true, wrap: true },
            }, [
                { label: "Cancel" },
                {
                    label: "Continue",
                    action: () => onSetProfilesVisible(!profilesVisible),
                },
            ]);
        }
        else {
            onSetProfilesVisible(!profilesVisible);
        }
    };
    toggleCustomTitlebar = () => {
        const { customTitlebar, onSetCustomTitlebar } = this.props;
        onSetCustomTitlebar(!customTitlebar);
    };
    toggleAdvanced = () => {
        const { advanced, onSetAdvancedMode } = this.props;
        onSetAdvancedMode(!advanced);
    };
    restart = () => {
        relaunch();
    };
}
function mapStateToProps(state) {
    return {
        profilesVisible: state.settings.interface.profilesVisible,
        hideTopLevelCategory: state.settings.interface.hideTopLevelCategory,
        advanced: state.settings.interface.advanced,
        desktopNotifications: state.settings.interface.desktopNotifications,
        autoDeployment: state.settings.automation.deploy,
        autoInstall: state.settings.automation.install,
        autoEnable: state.settings.automation.enable,
        autoStart: state.settings.automation.start,
        startMinimized: state.settings.automation.minimized,
        customTitlebar: state.settings.window.customTitlebar,
        minimizeToTray: state.settings.window.minimizeToTray,
        relativeTimes: state.settings.interface.relativeTimes,
        suppressedNotifications: state.settings.notifications.suppress,
        foregroundDL: state.settings.interface.foregroundDL,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetLanguage: (newLanguage) => {
            dispatch(setLanguage(newLanguage));
        },
        onSetAutoDeployment: (enabled) => {
            dispatch(setAutoDeployment(enabled));
        },
        onSetAutoInstall: (enabled) => {
            dispatch(setAutoInstall(enabled));
        },
        onSetAutoEnable: (enabled) => {
            dispatch(setAutoEnable(enabled));
        },
        onSetAutoStart: (start) => {
            dispatch(setAutoStart(start));
        },
        onSetStartMinimized: (minimized) => {
            dispatch(setStartMinimized(minimized));
        },
        onSetProfilesVisible: (visible) => {
            dispatch(setProfilesVisible(visible));
        },
        onSetAdvancedMode: (advanced) => {
            dispatch(setAdvancedMode(advanced));
        },
        onShowDialog: (type, title, content, actions) => dispatch(showDialog(type, title, content, actions)),
        onSetCustomTitlebar: (enable) => dispatch(setCustomTitlebar(enable)),
        onSetDesktopNotifications: (enabled) => {
            dispatch(setDesktopNotifications(enabled));
        },
        onSetHideTopLevelCategory: (skip) => {
            dispatch(setHideTopLevelCategory(skip));
        },
        onSetRelativeTimes: (enabled) => {
            dispatch(setRelativeTimes(enabled));
        },
        onResetNotificationSuppression: () => {
            dispatch(resetSuppression(null));
        },
        onSetForegroundDL: (enabled) => dispatch(setForegroundDL(enabled)),
    };
}
const SettingsInterfaceMapped = translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(SettingsInterfaceImpl));
function isValidLanguageCode(langId) {
    if (!truthy(langId)) {
        return false;
    }
    try {
        new Date().toLocaleString(langId);
        return true;
    }
    catch (err) {
        log("warn", "Not a valid language code", langId);
        return false;
    }
}
function readLocales(extensions) {
    const bundledLanguages = getVortexPath("locales");
    const userLanguages = path.normalize(path.join(getVortexPath("userData"), "locales"));
    const translationExts = extensions.filter((ext) => ext.type === "translation");
    let local = [];
    return PromiseBB.join(readExtensibleDir("translation", bundledLanguages, userLanguages)
        .map((file) => path.basename(file))
        .tap((files) => (local = files)), translationExts.map((ext) => ext.language))
        .then((fileLists) => Array.from(new Set([].concat(...fileLists))))
        .filter((langId) => isValidLanguageCode(langId))
        .then((files) => {
        // files contains just the unique languages being supported, but there
        // may be multiple extensions providing the same language
        const loc = new Set(local);
        const locales = files.map((key) => {
            let language;
            let country;
            const [languageKey, countryKey] = key.split("-");
            language = nativeLanguageName(languageKey);
            if (countryKey !== undefined) {
                country = nativeCountryName(countryKey);
            }
            const ext = loc.has(key)
                ? []
                : translationExts.filter((iter) => iter.language === key);
            return { key, language, country, ext };
        });
        return locales;
    })
        .catch((err) => {
        log("warn", "failed to read locales", err);
        return [];
    });
}
function SettingsInterface(props) {
    const [languages, setLanguages] = React.useState([]);
    const [iteration, setIteration] = React.useState(0);
    const { lang, exts } = useSelector((state) => ({
        lang: state.settings.interface.language,
        exts: state.session.extensions.available,
    }));
    const forceReload = React.useCallback(() => setIteration((i) => i + 1), []);
    React.useEffect(() => {
        (async () => {
            const langs = await readLocales(exts);
            // ensure the selected language is always an option
            if (langs.length === 0) {
                langs.push({
                    key: lang,
                    language: nativeLanguageName(lang),
                    ext: [],
                });
            }
            setLanguages(langs);
        })();
    }, [lang, exts, iteration]);
    return (React.createElement(SettingsInterfaceMapped, { ...props, currentLanguage: lang, extensions: exts, languages: languages, onReloadLanguages: forceReload }));
}
export default SettingsInterface;
